var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgElIconFacebookBrand = function SvgElIconFacebookBrand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#el-icon-facebook-brand_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.333 2.333h9.333v9.333H2.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C76BE",
    d: "M10.851 0H3.15A3.142 3.142 0 0 0 0 3.149v7.702A3.142 3.142 0 0 0 3.149 14h7.702A3.142 3.142 0 0 0 14 10.851V3.15A3.142 3.142 0 0 0 10.851 0Zm-1.89 4.505h-.823c-.339 0-.532.146-.581.533v.97h1.356L8.72 7.363H7.557v3.44H6.152v-3.44H4.99V6.007h1.162V5.087c0-.194 0-.339.049-.533.048-.387.29-.775.63-1.017.29-.194.629-.339 1.016-.339h.727c.145 0 .242.049.388.049v1.26-.002Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "el-icon-facebook-brand_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
};
export default SvgElIconFacebookBrand;